// src/features/userUsageTracker/userUsageTrackerActions.js
import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';

/* ------------------------------------------------------------------ */
/* Axios helper – reuse one base instance everywhere in the app      */
/* ------------------------------------------------------------------ */
const api = axios.create({
    baseURL: `${process.env.REACT_APP_BASEURL}/api/user-usage-tracker`,
    headers: {'Content-Type': 'application/json'},
});

/* ------------------------------------------------------------------ */
/* 1️⃣ Capture user activity (email, activity, ipAddress)             */
/*    payload shape ➜ { email, activity, ipAddress }                 */
/* ------------------------------------------------------------------ */
export const captureActivity = createAsyncThunk(
    'userUsageTracker/captureActivity',
    async (payload, {rejectWithValue, getState}) => {
        try {
            const state = getState();
            const token = state.user.accessToken;

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && {'Authorization': `Bearer ${token}`})
                }
            };

            const {data} = await api.post('/captureActivity', payload, config);
            return data;          // success response
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/* ------------------------------------------------------------------ */
/* 2️⃣ Get all user usage data (admin only - requires @thesealab.com) */
/* ------------------------------------------------------------------ */
export const getUserUsage = createAsyncThunk(
    'userUsageTracker/getUserUsage',
    async (_, {rejectWithValue, getState}) => {
        try {
            const state = getState();
            const token = state.user.accessToken;

            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && {'Authorization': `Bearer ${token}`})
                }
            };

            const {data} = await api.get('/get-user-usage', config);
            return data;          // { usage: [...] }
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);